
import { TextField, Autocomplete } from '@mui/material';
import React, { useEffect, useState } from 'react'
import loader from '../assets/images/loader.gif'
import axiosClient from '../axios';
import SideBar from './SideBar';
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
import Pagination_2 from './Pagination_2';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { dateConvert } from '../dateConverter';
import '../assets/css/AdminCommon.css'; // V4 Styles

const VideoStat = () => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [allProvider, setAllProvider] = useState([]);

    const [pagination, setPagination] = useState({
        page: 0,
        limit: 100
    });

    const [date, setDate] = useState({
        start: null,
        end: null,
    })

    const [triggerPoints, setTriggerPoints] = useState(0)

    const navigate = useNavigate()

    const getAllVideosStat = () => {
        if ((date?.start && date?.end) && (date?.start > date?.end)) {
            return alert("Start Date Can not be greater than End Date...")
        }

        let startDate = date?.start ? dateConvert(date?.start) : null
        let endDate = date?.end ? dateConvert(date?.end) : null
        setLoading(true)

        axiosClient
            .get(`/get-video-stat?page=${pagination.page}&limit=${pagination.limit}&s_date=${startDate}&e_date=${endDate}&triggerPoints=${triggerPoints}`)
            .then((res) => {
                console.log("res video stat", res)
                setData(res?.data?.response)
                setLoading(false)
            })
            .catch((error) => console.log(error))
            .finally(() => setLoading(false))
    }

    const getPartner = () => {
        axiosClient
            .get("/partnersList")
            .then((res) => setAllProvider(res.data.response))
            .catch((error) => console.log(error));
    }

    const getPartnerName = (partnerId) => {
        let partnerdata = allProvider.find((item) => item._id === partnerId)
        return partnerdata?.name
    }

    let optionsValue = {
        "1": "is profiler",
        "2": "surveydisqualification",
        "3": "surveycomplete",
        "4": "task-games complete",
        "5": "task-games failed",
        "6": "is partner",
        "7": "profiler complete",
        "8": "125 earning not complete 1hour",
        "9": "125 not complete 1 day",
        "10": "How to Do Ptc Video"
    }

    useEffect(() => {
        getAllVideosStat();
    }, [pagination.page, pagination.limit])

    useEffect(() => {
        getPartner();
    }, [])

    const clearFilters = () => {
        setDate({ start: null, end: null });
        setTriggerPoints(0);
        setPagination({ ...pagination, page: 0 });
    }

    return (
        <>
            <SideBar handleSideBar={true} activeTab={"allVideo"} />
            <div className="admin-screen-v4">
                <div className="admin-header-v4">
                    <h2>Video Statistics</h2>
                    <div className="dFlex" style={{ gap: "16px" }}>
                        <button
                            className="btn-secondary-v4"
                            onClick={() => navigate('/allVideo')}
                        >
                            Back to Videos
                        </button>
                    </div>
                </div>

                <div className="admin-form-container-v4" style={{ marginBottom: "24px" }}>
                    <div className="form-section-v4">
                        <h3 className="section-header-v4">Filter Options</h3>

                        <div className="form-row-v4 triple">
                            <div className="form-group-v4 autocomplete-wrapper-v4">
                                <label className="form-label-v4">Trigger Points</label>
                                <Autocomplete
                                    size="small"
                                    options={[
                                        { label: "All Trigger Points", value: 0 },
                                        { label: "is profiler", value: 1 },
                                        { label: "surveydisqualification", value: 2 },
                                        { label: "surveycomplete", value: 3 },
                                        { label: "task-games complete", value: 4 },
                                        { label: "task-games failed", value: 5 },
                                        { label: "is partner", value: 6 },
                                        { label: "profiler complete", value: 7 },
                                        { label: "125 earning not complete 1hour", value: 8 },
                                        { label: "125 not complete 1 day", value: 9 },
                                        { label: "How to Do Ptc Video", value: 10 }
                                    ]}
                                    value={
                                        [
                                            { label: "All Trigger Points", value: 0 },
                                            { label: "is profiler", value: 1 },
                                            { label: "surveydisqualification", value: 2 },
                                            { label: "surveycomplete", value: 3 },
                                            { label: "task-games complete", value: 4 },
                                            { label: "task-games failed", value: 5 },
                                            { label: "is partner", value: 6 },
                                            { label: "profiler complete", value: 7 },
                                            { label: "125 earning not complete 1hour", value: 8 },
                                            { label: "125 not complete 1 day", value: 9 },
                                            { label: "How to Do Ptc Video", value: 10 }
                                        ].find(item => item.value === triggerPoints) || null
                                    }
                                    onChange={(event, newValue) => {
                                        setTriggerPoints(newValue ? newValue.value : 0);
                                    }}
                                    getOptionLabel={(option) => option.label}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Trigger Points"
                                            size="small"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group-v4 date-picker-wrapper-v4">
                                <label className="form-label-v4">Start Date</label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={date?.start}
                                        onChange={(value) => setDate({ ...date, start: value })}
                                        renderInput={(params) => (
                                            <TextField {...params} size="small" fullWidth />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div className="form-group-v4 date-picker-wrapper-v4">
                                <label className="form-label-v4">End Date</label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={date?.end}
                                        onChange={(value) => setDate({ ...date, end: value })}
                                        renderInput={(params) => (
                                            <TextField {...params} size="small" fullWidth />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>

                        <div className="button-group-v4">
                            <button
                                className="cancel-button-v4"
                                onClick={clearFilters}
                            >
                                Clear Filters
                            </button>
                            <button
                                className="submit-button-v4"
                                onClick={getAllVideosStat}
                                // disabled={!(date?.start && date?.end)}
                            >
                                Get Statistics
                            </button>
                        </div>
                    </div>
                </div>

                {!loading ? (
                    <div className="admin-form-container-v4">
                        {data?.length > 0 ? (
                            <>
                                <div className="table-container-v4">
                                    <table className="data-table-v4">
                                        <thead>
                                            <tr>
                                                <th>S.NO.</th>
                                                <th>Partner Name</th>
                                                <th>Trigger Points</th>
                                                <th>User Name</th>
                                                <th>Phone Number</th>
                                                <th>Email</th>
                                                <th>Watched Full</th>
                                                <th>Skipped</th>
                                                <th>Shown At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((val, key) => (
                                                <tr key={key + 1}>
                                                    <td className="text-muted-v4">
                                                        {(pagination.page * pagination.limit) + (key + 1)}
                                                    </td>
                                                    <td className="text-link-v4">
                                                        {val?.video?.triggerpoints == 6 ? getPartnerName(val?.video?.partnerId) : "—"}
                                                    </td>
                                                    <td>
                                                        <span className="earning-badge-v4 type-2">
                                                            {optionsValue[val?.video?.triggerpoints] || "—"}
                                                        </span>
                                                    </td>
                                                    <td className="text-link-v4">
                                                        {val?.user?.name || "—"}
                                                    </td>
                                                    <td className="text-mono-v4">
                                                        {val?.user?.phoneNumber || "—"}
                                                    </td>
                                                    <td className="text-link-v4">
                                                        {val?.user?.emailId || "—"}
                                                    </td>
                                                    <td>
                                                        <span className={`status-badge-v4 ${val?.sawFullVideo ? "status-1" : "status-2"
                                                            }`}>
                                                            {val?.sawFullVideo ? "Yes" : "No"}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`status-badge-v4 ${val?.skipsVideo ? "status-1" : "status-4"
                                                            }`}>
                                                            {val?.skipsVideo ? "Yes" : "No"}
                                                        </span>
                                                    </td>
                                                    <td className="text-muted-v4">
                                                        {val?.shownAt ?
                                                            moment.utc(val?.shownAt).local().format("MMM Do YY, h:mm:ss a") :
                                                            "—"
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="pagination-v4">
                                    <div className="pagination-buttons-v4">
                                        <Pagination_2
                                            filterDataInput={pagination}
                                            setFilterDataInput={setPagination}
                                            showNext={data?.length === pagination.limit}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="empty-state-v4">
                                <div className="empty-icon-v4">📊</div>
                                <h3>No Video Statistics Found</h3>
                                <p>Try adjusting your filters or select a date range</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="loader-container-v4">
                        <img src={loader} alt="Loading..." className="loader-image-v4" />
                    </div>
                )}
            </div>
        </>
    )
}

export default VideoStat;
